import React, { useState, useEffect } from "react";
import { Button, InputAdornment, MenuItem, Select, TextField, Typography, CircularProgress } from "@mui/material";
import { DynamicBoxes } from "./DynamicBoxes";
import { BatteryCells } from "./BatteryCells";
import { BatteryCellPlots } from "./BatteryCellPlots";
import { BatteryCellMasterPlot } from "./BatteryCellMasterPlot";
import cylindrical from "../../assets/img/newcellWObg.png";
import prismatic from "../../assets/img/prismatic.png";
import pouch from "../../assets/img/newPouch.png";
import circuitImage from "../../assets/img/portfolio/newCell2.jpg";
import { GhostLinks } from "./GhostLinks";
import PlotComponent from "../CellInfo/PlotComponent";
import { Tabs, Tab, Box } from '@mui/material';
import axios from 'axios';

const BatteryConfig = () => {
  const [cellType, setCellType] = useState("Cylindrical");
  const [cellCondition, setCellCondition] = useState("Recycled cell");
  const [voltage, setVoltage] = useState(30);
  const [capacity, setCapacity] = useState(10);
  const [num_cols, setNum_cols] = useState(9);
  const [div_html, setDivHtml] = useState([]);
  const [packVoltage, setPackVoltage] = useState(33.3);
  const [packCapacity, setPackCapacity] = useState(10);
  const [packWeight, setPackWeight] = useState(1.3);
  const [totalCells, setTotalCells] = useState(18);
  const [packPrice, setPackPrice] = useState(108);
  const [isConfig, setIsConfig] = useState(false);
  const [cellImage, setCellImage] = useState(cylindrical);
  const [cellsData, setCellsData] = useState([]);
  const [modules, setModules] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [csvData, setCsvData] = useState(null);
  const [filePlot, setFilePlot] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tabValue, setTabValue] = useState(0);


  const batteryConfig = () => {
    setIsConfig(true);
    const wt = 72;
    const default_cell_capacity = 5;
    const num_row = Math.ceil(capacity / default_cell_capacity);
    const num_cols = Math.ceil(voltage / 3.7);
    const total_cap = default_cell_capacity * num_row;
    const total_wt = (wt * num_cols * num_row) / 1000;
    const total_cells = num_row * num_cols;
    setTotalCells(total_cells);
    setNum_cols(num_cols);
    setPackVoltage(Math.round(num_cols * 3.7 * 100) / 100);
    setPackCapacity(Math.round(total_cap * 100) / 100);
    setPackWeight(Math.round(total_wt * 100) / 100);
    let tempDivs = [];
    for (let i = 0; i < total_cells; i++) {
      tempDivs.push(
        <div className="mybox">
          <img src={cellImage} style={{ width: "100%", backgroundColor: "black" }} />
        </div>,
      );
    }
    setCellImage(circuitImage);
    setDivHtml(tempDivs);
  };
  const BatteryProcure = () => {
    if (cellType === "Prismatic") setCellImage(prismatic);
    else if (cellType === "Cylindrical") setCellImage(cylindrical);
    else setCellImage(pouch);
    setIsConfig(false);
    const wt = 72;
    const pricePerCellOld = 3;
    const pricePerCellNew = 6;
    const default_cell_capacity = 5;
    const num_row = Math.ceil(capacity / default_cell_capacity);
    const num_cols = Math.ceil(voltage / 3.7);
    const total_cap = default_cell_capacity * num_row;
    const total_cells = num_row * num_cols;
    const total_wt = (wt * num_cols * num_row) / 1000;
    setTotalCells(Math.round(num_cols * num_row));
    setPackVoltage(Math.round(num_cols * 3.7 * 100) / 100);
    setPackCapacity(Math.round(total_cap * 100) / 100);
    setPackWeight(Math.round(total_wt * 100) / 100);
    setNum_cols(num_cols);
    if (cellCondition === "Recycled cell") {
      setPackPrice(total_cells * pricePerCellOld);
    } else {
      setPackPrice(total_cells * pricePerCellNew);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'text/csv') {
      setSelectedFile(file);
      setCsvData(null); // Clear previous data
    } else {
      alert('Please upload a valid CSV file.');
      setSelectedFile(null);
    }
  };

  const handleShowPlot = async () => {
    if (!selectedFile) return;

    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await axios.post(`${process.env.BACKEND_URL}batteries/battery_pack_plot`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        console.log(response.data);
        setFilePlot(response.data);
      } else {
        setError('Failed to upload file.');
      }
    } catch (error) {
      setError('Error uploading file: ' + error.message);
    } finally {
      setLoading(false);
    }
  };


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  return (
    <div className="flex flex-col justify-center items-center text-center gap-12 w-full">
      <div className="flex flex-col items-center w-full gap-10">
        <div className="rounded-md p-8 flex flex-col gap-8 items-center justify-between w-[38%]  medium:w-[70%] max-sm:w-[80%] shadow-[0px_0px_11px_0px_#e8442d]">
          <div className="flex flex-row item-center justify-between w-full max-md:flex-col max-md:items-start max-md:gap-2">
            <label htmlFor="voltage" className="max-md:w-full max-md:text-left">
              Battery Voltage
            </label>
            <div className="flex flex-row justify-center items-center w-1/2 max-md:w-full">
              <TextField
                fullWidth
                className="max-md:w-full"
                variant="outlined"
                size="small"
                type="number"
                value={voltage}
                onChange={(e) => setVoltage(e.target.value)}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "0.3rem",
                  fontFamily: "Bai Jamjuree",
                  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ff851b",
                  },
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ff851b",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography sx={{
                        fontWeight: "700", fontFamily: "Bai Jamjuree"
                      }}>V</Typography>
                    </InputAdornment>
                  ),
                  inputProps: {
                    style: {
                      fontWeight: "700",
                      fontFamily: "Bai Jamjuree",
                    },
                  },
                }}
              />
            </div>
          </div>
          <div className="flex flex-row item-center justify-between w-full max-md:flex-col max-md:items-start max-md:gap-2">
            <label htmlFor="capacity" className="max-md:w-full max-md:text-left">
              Battery Capacity
            </label>
            <div className=" flex flex-row justify-center items-center w-1/2 max-md:w-full">
              <TextField
                fullWidth
                id="capactiy"
                className="max-md:w-full"
                variant="outlined"
                size="small"
                type="number"
                value={capacity}
                onChange={(e) => setCapacity(e.target.value)}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "0.3rem",
                  fontFamily: "Bai Jamjuree",
                  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ff851b",
                  },
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ff851b",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography sx={{
                        fontWeight: "700", fontFamily: "Bai Jamjuree"
                      }}>Ah</Typography>
                    </InputAdornment>
                  ),
                  inputProps: {
                    style: {
                      fontWeight: "700",
                      fontFamily: "Bai Jamjuree",
                    },
                  },
                }}
              />
            </div>
            {/* </div> */}
          </div>
          <Button
            fullWidth
            className="max-xsm:text-xs"
            variant="outlined"
            size="large"
            sx={{
              borderColor: "#ff851b",
              backgroundColor: "#e8442d",
              color: "white",
              fontWeight: "900",
              fontFamily: "Bai Jamjuree",
              "&:hover": {
                borderColor: "#ffae68",
                backgroundColor: "#eb5a46",
              },
            }}
            onClick={batteryConfig}
          >
            Create Your Battery Configuration
          </Button>
        </div>
        <div className="rounded-md p-8 flex flex-col gap-8 items-center justify-between w-[38%] medium:w-[70%] max-sm:w-[80%] shadow-[0px_0px_11px_0px_#e8442d]">
          <div className="flex flex-row item-center justify-between w-full max-md:flex-col max-md:items-start max-md:gap-2">
            <label htmlFor="voltage" className="max-md:w-full max-md:text-left">
              Enter Cell Type
            </label>
            <div className="flex flex-row justify-center items-center w-1/2 max-md:w-full">
              <Select
                value={cellType}
                name="cellType"
                className="max-md:w-full"
                onChange={(e) => setCellType(e.target.value)}
                id="cellType"
                fullWidth
                size="small"
                sx={{
                  backgroundColor: "white",
                  fontWeight: "700",
                  fontFamily: "Bai Jamjuree",
                }}
              >
                <MenuItem value={"Cylindrical"} sx={{ fontWeight: "700", fontFamily: "Bai Jamjuree" }}>
                  Cylindrical
                </MenuItem>
                <MenuItem value={"Pouch"} sx={{ fontWeight: "700", fontFamily: "Bai Jamjuree" }}>
                  Pouch
                </MenuItem>
                <MenuItem value={"Prismatic"} sx={{ fontWeight: "700", fontFamily: "Bai Jamjuree" }}>
                  Prismatic
                </MenuItem>
              </Select>
            </div>
          </div>
          <div className="flex flex-row item-center justify-between w-full max-md:flex-col max-md:items-start max-md:gap-2">
            <label htmlFor="capacity" className="max-md:w-full max-md:text-left">
              Enter Cell Condition
            </label>
            <div className="flex flex-row justify-center items-center w-1/2 max-md:w-full">
              <Select
                value={cellCondition}
                name="ellCondition"
                className="max-md:w-full"
                onChange={(e) => setCellCondition(e.target.value)}
                id="cellCondition"
                fullWidth
                size="small"
                sx={{
                  backgroundColor: "white",
                  fontWeight: "700",
                  fontFamily: "Bai Jamjuree",
                }}
              >
                <MenuItem value={"Recycled cell"} sx={{ fontWeight: "700", fontFamily: "Bai Jamjuree" }}>
                  Recycled cell
                </MenuItem>
                <MenuItem value={"New cell"} sx={{ fontWeight: "700", fontFamily: "Bai Jamjuree" }}>
                  New cell
                </MenuItem>
              </Select>
            </div>
          </div>
          {/* </div> */}

          <Button
            fullWidth
            onClick={BatteryProcure}
            className="max-xsm:text-xs"
            variant="outlined"
            size="large"
            sx={{
              borderColor: "#ff851b",
              backgroundColor: "#e8442d",
              color: "white",
              fontWeight: "900",
              fontFamily: "Bai Jamjuree",
              "&:hover": {
                borderColor: "#ffae68",
                backgroundColor: "#eb5a46",
              },
            }}
          >
            Procure Your Cells
          </Button>
        </div>
      </div>
      <div className="rounded-md p-8 flex flex-col gap-8 items-center justify-between w-[38%] medium:w-[70%] max-sm:w-[80%] shadow-[0px_0px_11px_0px_#e8442d]">
        <div className="flex flex-row item-center justify-between w-full max-md:flex-col max-md:items-start max-md:gap-2">
          <label htmlFor="csvUpload" className="max-md:w-full max-md:text-left">
            Upload CSV File
          </label>
          <div className="flex flex-row justify-center items-center w-1/2 max-md:w-full">
            <input
              type="file"
              accept=".csv"
              id="csvUpload"
              onChange={handleFileChange}
              className="hidden"
            />
            <label
              htmlFor="csvUpload"
              className="flex items-center cursor-pointer border rounded p-2 bg-white shadow-md hover:bg-gray-100"
            >
              <Typography sx={{ fontWeight: "700", fontFamily: "Bai Jamjuree" }}>
                {selectedFile ? selectedFile.name : "Choose CSV File"}
              </Typography>
            </label>
          </div>
        </div>
        <Button
          fullWidth
          disabled={!selectedFile}
          onClick={handleShowPlot}
          className="max-xsm:text-xs"
          variant="outlined"
          size="large"
          sx={{
            borderColor: "#ff851b",
            backgroundColor: "#e8442d",
            color: "white",
            fontWeight: "900",
            fontFamily: "Bai Jamjuree",
            "&:hover": {
              borderColor: "#ffae68",
              backgroundColor: "#eb5a46",
            },
          }}
        >
          {loading ? <CircularProgress size={24} /> : 'Show Plot'}
        </Button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div>
      {filePlot &&
        <>
          <h1 className="text-xl text-[#e8442d] underline text-center md:text-xl lg:text-2xl">
            Battery Data Plot
          </h1>
          <PlotComponent plotData={filePlot} />
        </>
      }
      <p className="text-lg text-center md:text-xl lg:text-3xl w-[80%] ">
        We offer fully-characterized recycled cells with decent SoH at bargain price{" "}
        <span className="text-[#e8442d]">(approx. 50% cheaper)</span>
      </p>
      <p className="text-sm text-center md:text-lg lg:text-xl w-[70%]">
        Our CellScope engine will fetch most-uniform bunch of cells for your pack from our
        warehouse, which stores large number of fully-characterized new and old cells.
      </p>
      <DynamicBoxes
        packVoltage={packVoltage}
        packCapacity={packCapacity}
        packWeight={packWeight}
        totalCells={totalCells}
        packPrice={packPrice}
        isConfig={isConfig}
      />
      <BatteryCells
        cellsData={cellsData}
        setCellsData={setCellsData}
        num_cols={num_cols}
        div_html={div_html}
        isConfig={isConfig}
        cellImage={cellImage}
        totalCells={totalCells}
      />
      {!isConfig && cellsData && cellsData.length !== 0 && (
        <>
          <h1 className="text-xl text-[#e8442d] text-center md:text-2xl lg:text-4xl">
            Battery Pack Cell Variability Analysis
          </h1>
          <Box sx={{ width: '100%' }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              centered
              indicatorColor="secondary"
              textColor="inherit"
              variant="fullWidth"
              sx={{
                '& .MuiTab-root': {
                  fontWeight: 'bold',
                  fontFamily: 'Bai Jamjuree, sans-serif',
                },
              }}
            >
              <Tab label="Capacity vs Cycle Plots" />
              <Tab label="IR vs Cycle Plots" />
              {/* <Tab label="EIS Plots" /> */}
              <Tab label="Master Capacity vs Cycle" />
              <Tab label="Master IR vs Cycle" />
            </Tabs>
          </Box>

          {tabValue === 0 && (
            <>
              <h1 className="text-xl text-[#e8442d] underline text-center md:text-xl lg:text-2xl">
                Modules Variability Capacity vs Cycle Plots
              </h1>
              <BatteryCellPlots
                cellsData={cellsData}
                num_cols={num_cols}
                totalCells={totalCells}
                url="battery_variance_capacity_vs_cycle"
                plotType="Capacity vs Cycle Plot"
              />
            </>
          )}
          {tabValue === 1 && (
            <>
              <h1 className="text-xl text-[#e8442d] underline text-center md:text-xl lg:text-2xl">
                Modules Variability IR vs Cycle Plots
              </h1>
              <BatteryCellPlots
                cellsData={cellsData}
                num_cols={num_cols}
                totalCells={totalCells}
                url="battery_variance_ir_vs_cycle"
                plotType="IR vs Cycle Plot"
              />
            </>
          )}
          {/* {tabValue === 2 && (
            <>
              <h1 className="text-xl text-[#e8442d] underline text-center md:text-xl lg:text-2xl">
                Modules Variability EIS Plots
              </h1>
              <BatteryCellPlots
                cellsData={cellsData}
                num_cols={num_cols}
                totalCells={totalCells}
                url="battery_variance_eis"
                plotType="EIS Plot"
              />
            </>
          )} */}
          {tabValue === 2 && (
            <>
              <div className="flex flex-col border border-[#e8432d29] bg-[#111111] rounded-lg w-[100%] py-5">
                <h1 className="text-xl text-[#ffffff] underline text-center md:text-xl lg:text-2xl">
                  Master Plot Capacity vs Cycle Plots
                </h1>
                <BatteryCellMasterPlot
                  cellsData={cellsData}
                  num_cols={num_cols}
                  totalCells={totalCells}
                  url="battery_variance_master_capacity_vs_cycle"
                />
              </div>
            </>
          )}
          {tabValue === 3 && (
            <>
              <div className="flex flex-col border border-[#e8432d29] bg-[#111111] rounded-lg w-[100%] py-5">
                <h1 className="text-xl text-[#ffffff] underline text-center md:text-xl lg:text-2xl">
                  Master Plot IR vs Cycle Plots
                </h1>
                <BatteryCellMasterPlot
                  cellsData={cellsData}
                  num_cols={num_cols}
                  totalCells={totalCells}
                  url="battery_variance_master_ir_vs_cycle"
                />
              </div>
            </>
          )}
        </>
      )}

      <GhostLinks />
    </div>
  );
};

export default BatteryConfig;
